import { Auth } from 'aws-amplify'

export async function checkCurrentAuthenticatedUser(): Promise<void> {
    await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    })
        .catch((err) => {
            console.error(err)
            Auth.signOut()
            throw err;
        })
}
